import api from 'api'

export const scheduleWorkItemUpdate = async (
  associationId: number
): Promise<void> => {
  await api.post(`/admin/dayforce/schedule_work_item_update`, {
    association_id: associationId,
  })
}
